<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .refresh-content {
    margin-top: utils.in_rem(16px);
  }

  .table-container {
    min-height: 300px;
    overflow: auto;
  }

  .mapping-settings {
    margin-top: utils.in_rem(16px);
  }
</style>

<script>
  import Accordion from "../../../components/shared/Accordion.svelte";
  import ContactTypesDropdown from "./ContactTypesDropdown.svelte";
  import LoadingState from "./LoadingState.svelte";
  import MappingSettings from "./MappingSettings.svelte";
  import RefreshStats from "./RefreshStats.svelte";
  import RefreshTable from "./RefreshTable.svelte";

  import { dataRefreshStore } from "../../../stores";

  const { meta } = dataRefreshStore;

  export let providerTitle;
  export let contactTypeOptions;

  // Format large numbers to display with K or M suffix, rounded to nearest 1000
  const formatNumber = (num) => {
    if (!num) return "0";

    if (num < 1000) {
      return num.toString();
    }

    if (num >= 1000000) {
      return `${(Math.round(num / 100000) / 10).toFixed(1)}M`;
    }

    return `${Math.round(num / 1000)}K`;
  };

  // Format metrics for display
  $: stats = {
    dataFields: {
      value: formatNumber(
        $dataRefreshStore.metrics.updatedFields +
          $dataRefreshStore.metrics.verifiedFields
      ),
      label: "Refreshed",
    },
    contacts: {
      value: formatNumber(
        $dataRefreshStore.metrics.updated + $dataRefreshStore.metrics.verified
      ),
      label: "Refreshed",
      oldestDate: $dataRefreshStore.metrics.oldestDate || "16/06/2024",
    },
  };

  let advancedMappingExpanded = false;
</script>

<div class="refresh-content">
  <ContactTypesDropdown {providerTitle} {contactTypeOptions} />

  {#if $meta.fetching}
    <LoadingState />
  {:else}
    <RefreshStats {stats} />
    <div class="table-container">
      <RefreshTable recentRefreshes={$dataRefreshStore.recentRefreshes} />
    </div>
  {/if}

  <div class="mapping-settings">
    <Accordion
      size="small"
      headerText="Advanced mapping settings"
      bind:isExpanded={advancedMappingExpanded}
    />
    {#if advancedMappingExpanded}
      <MappingSettings />
    {/if}
  </div>
</div>
